import React from 'react';

import { Separator } from '@dashboard/components/ui/separator';
import { Skeleton } from '@dashboard/components/ui/skeleton';

const SectionTitle: React.FC<{ width: string }> = ({ width }) => (
  <Skeleton className={`h-6 ${width}`} />
);

const TextField: React.FC<{ labelWidth: string }> = ({ labelWidth }) => (
  <div className="space-y-1">
    <Skeleton className={`h-5 ${labelWidth}`} />
    <Skeleton className="h-8 w-full" />
  </div>
);

const AddBookingSkeleton: React.FC = () => (
  <div role="status" aria-label="Loading the booking form">
    <div className="space-y-4">
      <section className="space-y-3">
        <SectionTitle width="w-20" />
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-[66px] w-full rounded-lg" />
        <Skeleton className="h-[66px] w-full rounded-lg" />
      </section>

      <Separator />

      <section className="space-y-3">
        <SectionTitle width="w-20" />
        <div className="space-y-4">
          <TextField labelWidth="w-14" />
          <TextField labelWidth="w-28" />
        </div>
      </section>

      <Separator />

      <section className="space-y-3">
        <SectionTitle width="w-20" />
        <Skeleton className="h-8 w-full" />
      </section>

      <Separator />

      <section>
        <SectionTitle width="w-24" />
        <Skeleton className="mt-0.5 mb-3 h-5 w-80 max-w-full" />
        <div className="space-y-2.5">
          {['w-16', 'w-28', 'w-28'].map((width, index) => (
            <div key={index} className="flex items-start gap-x-1.5">
              <Skeleton className="mt-1 size-4 shrink-0 rounded-full" />
              <div className="space-y-0.5">
                <Skeleton className={`h-5 ${width}`} />
                <Skeleton className="h-4 w-60" />
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="py-3">
        <Skeleton className="h-5 w-36" />
      </div>
    </div>

    <div className="mt-4 flex items-center justify-between gap-4">
      <Skeleton className="h-10 w-[68px]" />
      <Skeleton className="h-10 w-[107px]" />
    </div>
  </div>
);

export default AddBookingSkeleton;
